import { CommonDocumentService } from '@savgroup-front-common/core/api';

export const DocumentService = {
  downloadDocument: CommonDocumentService.downloadDocument,
  downloadDocumentAdditionalInformation:
    CommonDocumentService.downloadDocumentAdditionalInformation,
};
